module.exports = __webpack_public_path__ + "media/images/games/league-of-legends/rectangle-a623f772546b88e294a920845064ce70.jpg";